import React from 'react';
import { Text, TextMarkup } from '../text';
import { BadgeTextDirection } from './BadgeEnum';
import { has } from '../../services';
import { getColorClassName } from '../../objects/facets';
import clsx from 'clsx';
import { hashClass } from '../../helpers';
import { useTrilogyContext } from '../../context';
/**
 * Badge Component
 * @param children {React.ReactNode} If no content add children (Icon for example)
 * @param textContent {string} Content text for badge with text, if textContent props, it will display badge with text
 * @param content {string|number} Badge content text
 * @param direction {BadgeTextDirection} Text direction for Badge (LEFT|RIGHT)
 * @param color {BadgeColor} Change color for Badge
 * @param onClick {Function} onClick Event for Badge
 * - -------------------------- WEB PROPERTIES -------------------------------
 * @param className {string} Additionnal CSS Classes (ONLY FOR WEB)
 */
const Badge = ({ children, className, textContent, content, direction, color, onClick, testId, ...others }) => {
    const { styled } = useTrilogyContext();
    const classes = hashClass(styled, clsx(textContent ? 'badge-and-text' : 'badge', className));
    if (textContent) {
        return (React.createElement("div", { "data-testid": testId, onClick: (e) => {
                onClick === null || onClick === void 0 ? void 0 : onClick(e);
                e.stopPropagation();
            }, className: classes, ...others },
            (!direction || direction === BadgeTextDirection.LEFT) && React.createElement(Text, { markup: TextMarkup.P }, textContent),
            React.createElement("span", { className: hashClass(styled, clsx(color && has(`background-${getColorClassName(color)}`), 'badge is-level')) }, content || children),
            direction === BadgeTextDirection.RIGHT && React.createElement(Text, { markup: TextMarkup.P }, textContent)));
    }
    return (React.createElement("div", { "data-testid": testId, onClick: (e) => {
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
            e.stopPropagation();
        } },
        React.createElement(Text, { className: clsx(color && has(`background-${getColorClassName(color)}`), textContent ? 'badge-and-text' : 'badge', className), markup: TextMarkup.SPAN, ...others }, content || children)));
};
export default Badge;
//# sourceMappingURL=Badge.js.map